import React, { useState } from 'react';
import { FaWhatsapp, FaTimes } from 'react-icons/fa';
import { WHATSAPP_CHAT_URL, WHATSAPP_CHANNEL_URL, WHATSAPP_NUMBER } from '../../common/constants';

const FloatingWhatsAppButton = () => {
  const [showOptions, setShowOptions] = useState(false);

  const toggleOptions = () => {
    setShowOptions(!showOptions);
  };

  return (
    <div style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 1000 }}>
      {/* Options Panel */}
      {showOptions && (
        <div
          style={{
            position: 'absolute',
            bottom: '80px',
            right: '0',
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '15px',
            boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
            minWidth: '220px',
            border: '1px solid #e0e0e0'
          }}
        >
          <div style={{ marginBottom: '12px' }}>
            <a
              href={WHATSAPP_CHAT_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '10px',
                backgroundColor: '#25D366',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '500'
              }}
            >
              <FaWhatsapp size={18} />
              <div>
                <div>Contact on -</div>
                <div style={{ fontSize: '12px', opacity: 0.9 }}>+91 {WHATSAPP_NUMBER}</div>
              </div>
            </a>
          </div>
          
          <div>
            <a
              href={WHATSAPP_CHANNEL_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '10px',
                backgroundColor: '#075E54',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '500'
              }}
            >
              <FaWhatsapp size={18} />
              <div>Follow Channel</div>
            </a>
          </div>
        </div>
      )}

      {/* Main Button */}
      <button
        onClick={toggleOptions}
        style={{
          width: '60px',
          height: '60px',
          backgroundColor: showOptions ? '#075E54' : '#25D366',
          borderRadius: '50%',
          border: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          animation: showOptions ? 'none' : 'pulse 2s infinite'
        }}
        onMouseEnter={(e) => {
          if (!showOptions) {
            e.target.style.transform = 'scale(1.1)';
            e.target.style.boxShadow = '0 6px 20px rgba(37, 211, 102, 0.4)';
          }
        }}
        onMouseLeave={(e) => {
          if (!showOptions) {
            e.target.style.transform = 'scale(1)';
            e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
          }
        }}
        title={showOptions ? 'Close WhatsApp options' : 'WhatsApp options'}
      >
        {showOptions ? (
          <FaTimes size={24} color="white" />
        ) : (
          <FaWhatsapp size={28} color="white" />
        )}
      </button>

      <style jsx>{`
        @keyframes pulse {
          0% {
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
          }
          70% {
            box-shadow: 0 0 0 10px rgba(37, 211, 102, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
          }
        }
      `}</style>
    </div>
  );
};

export default FloatingWhatsAppButton;